<li class="upload-file">
    <a class="fa fa-paperclip" title="{{{o.tooltip_upload_file}}}"></a>
    <input type="file" class="fileupload" multiple style="display:none"/>
</li> 
